import { smScreen } from '../../lib/constants';
import { Switch } from '../Switch';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { Button } from '../Button/NewButton';
import { ReactNode } from 'react';

interface Props {
  customActions?: ReactNode;
  disabled: boolean;
  expandAll: boolean;
  header: string | ReactNode;
  onReset(): void;
  orientation: 'horizontal' | 'vertical';
  onToggle(expand: boolean): void;
}

export const Header = ({
  customActions = null,
  disabled,
  expandAll,
  header,
  onReset,
  orientation,
  onToggle,
}: Props) => {
  const isMobile = useMediaQuery(smScreen);

  return (
    <div className="flex flex-row flex-wrap items-center justify-between">
      {typeof header === 'string' ? (
        <h1 className="text-[2em]">{header}</h1>
      ) : (
        header
      )}
      {orientation === 'vertical' ? (
        <Switch
          color="primary"
          checked={expandAll}
          onChange={(event) => onToggle(event.currentTarget.checked)}
          label={expandAll ? 'Collapse Steps' : 'Expand Steps'}
          position="end"
          direction="row"
        />
      ) : null}
      <div className="flex gap-2">
        {customActions}
        <Button fullWidth={isMobile} disabled={disabled} onClick={onReset}>
          Start Over
        </Button>
      </div>
    </div>
  );
};
